import React, { Component } from "react";
import Select from "react-select";

const tipoCuenta = {
  ahorro_vista: "AHORRO_VISTA",
  ahorro_programado: "AHORRO_PROGRAMADO",
  rueda_gigante: "RUEDA_GIGANTE",
};

export default class LimiteTarjetaCredito extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.itemSelected,
      opcion: []
    };
  }

  componentDidMount() {

  }

  obtenerLimite() {
   if(this.props.limite == undefined || this.props.limite == "")
   return(<span/>)
    return (
        <label className="input-label-bold limite-minimo-label" >
          Límite Mínimo : {this.props.limite} GS.
        </label>
    );
   
  } 

  render() {
    const { selectedOption } = this.state;
    return (
      <div className="col-md-12">
        <div className="form-group">
          {this.obtenerLimite()}
        </div>
      </div>
    );
  }
}
